module.exports = __webpack_public_path__ + "img/frontend.1a6a44ab.png";